<template>
  <div class="search-staff-manager" v-click-outside="hideStaffWithDelay">
    <div style="display: -webkit-box">
      <b-form-input
        v-model="staffKeyword"
        @input="fetchStaffOptions"
        @focus="actionFocusSearchEmployee"
        :debounce="500"
        class="form-control f12 hc-37"
        autocomplete="off"
        placeholder="Quản lý"
      />
      <b-spinner label="Spinning" small class="m-t-10 ml-2" v-if="loadingStaff"></b-spinner>
    </div>

    <div class="search-staff-dropdown" v-if="showDropdown">
      <div v-if="!loadingStaff" class="scrollable-container">
        <template v-if="staffIdOptions.length > 0">
          <div class="add-user">
            <b-list-group-item
              v-for="(user, index) in staffIdOptions"
              :key="index"
              @click="selectStaff(user)"
              class="d-flex justify-content-between align-items-center staff-user"
            >
              <div class="au-detail">
                <span><img src="@/assets/img/avatar1.png" /></span>
                <article>
                  <p>
                    <span class="username mr-2">{{ user.name }}</span>
                    <span class="username mr-2">{{ user.userName }}</span>
                  </p>
                </article>
              </div>
            </b-list-group-item>
          </div>
        </template>
        <div v-else class="add-user no-data p-3" style="width: 200px">Không có dữ liệu</div>
      </div>
    </div>
  </div>
</template>

<script>
  import { debounce } from 'vue2-debounce'
  import { showMess } from '@/config/utils'
  import { SearchStaffInferior } from '@/services/customer-support/staff'

  export default {
    props: {
      value: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        staffKeyword: '',
        loadingStaff: false,
        showDropdown: false,
        staffIdOptions: [],
        selectedStaffName: '',
      }
    },

    directives: {
      'click-outside': {
        bind: (el, binding, vnode) => {
          el.clickOutsideEvent = event => {
            if (!(el == event.target || el.contains(event.target))) {
              vnode.context[binding.expression](event)
            }
          }
          document.body.addEventListener('click', el.clickOutsideEvent)
        },
        unbind: el => {
          document.body.removeEventListener('click', el.clickOutsideEvent)
        },
      },
    },

    watch: {
      value(newVal) {
        if (!newVal) {
          this.staffKeyword = ''
          this.selectedStaffName = ''
        }
      },
    },

    methods: {
      fetchStaffOptions: debounce(async function () {
        try {
          this.loadingStaff = true
          const getListParams = {
            limit: 10,
            keyWord: this.staffKeyword || '',
          }
          const res = await SearchStaffInferior(getListParams)
          console.log('SearchStaffInferior response:', res.data)
          this.staffIdOptions = res.data
        } catch (error) {
          showMess(this, 'Thông báo', error.message, 'danger', 'b-toaster-top-right', 5000)
        } finally {
          this.loadingStaff = false
        }
      }, 500),

      actionFocusSearchEmployee() {
        if (!this.showDropdown) {
          this.showDropdown = true
          if (this.staffIdOptions.length === 0) {
            this.fetchStaffOptions()
          }
        }
      },

      hideStaffWithDelay() {
        this.showDropdown = false
      },

      selectStaff(user) {
        console.log('Selected user:', user)
        console.log('user.id:', user.id)
        this.selectedStaffName = user.name
        this.staffKeyword = user.name
        this.$emit('input', user.id)
        this.$emit('change', user)
        this.showDropdown = false
      },

      clearSelection() {
        this.staffKeyword = ''
        this.selectedStaffName = ''
        this.$emit('input', '')
      },
    },
  }
</script>

<style lang="scss" scoped>
  .search-staff-manager {
    position: relative;
  }

  .staff-user {
    cursor: pointer;
  }

  .search-staff-dropdown {
    position: absolute;
    z-index: 1100;
    margin-top: 5px;
    border: 1px solid rgba(0, 0, 0, 0.125);
    width: 100%;
  }

  .scrollable-container {
    max-height: 200px;
    overflow-y: scroll;
    border-radius: 5px;
  }

  .au-detail {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 5px;

    &:hover {
      background: #00000021;
    }

    & > span {
      display: inline-block;
      border-radius: 50%;
      overflow: hidden;
      margin-right: 10px;
      width: 30px;
    }

    & > article {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: calc(100% - 60px);
      overflow: hidden;

      p {
        margin-bottom: 0;
        line-height: 15px;
        color: #333;
        font-weight: 700;
        flex: 1;
        overflow: hidden;

        & > span {
          font-weight: normal;
          display: block;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      b {
        text-align: right;
        color: #13569f;
        flex-shrink: 0;
        margin-left: 10px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 100px;
      }
    }
  }

  .list-group-item {
    padding: 0;
  }

  .add-user {
    width: 100%;
    background: #fff;
    box-shadow: 0px 0px 10px -6px;

    ul {
      max-height: 300px;
      overflow: auto;
    }
  }
</style>
